import React, { useState, useEffect } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { Row, Col, Card, CardBody, Button, Container } from 'reactstrap'
import { fetchEmployeeDropdownAutoList } from "store/actions";
import Breadcrumbs from "components/Common/Breadcrumb";
import TableContainer from "components/Common/TableContainer";



const EmployeeIncrementReport = () => {
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [data, setData] = useState([]);

  const [authDetails, setAuthDetails] = useState(null);

  const dispatch = useDispatch()

  const { dropdownAutoList } = useSelector((state) => state.EmployeeDetailsReducer || {});

  const [selectedEmployee, setSelectedEmployee] = useState(null);

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchEmployeeDropdownAutoList(unitId));
  }, [dispatch]);

  const sampleData = [
    {
    employeeCode: "EMP001",
    employeeName: "Suresh Kumar",
    incrementDate: "01.07.2024",
    incrementType: "Annual",
    basicDA: 25000.00,
    hra: 8000.00,
    conveyance: 2000.00,
    washing: 1500.00,
    gross: 36500.00,
    revision: "Revision 1",
  },
  {
    employeeCode: "EMP002",
    employeeName: "Revathi",
    incrementDate: "01.08.2024",
    incrementType: "Mid-Year",
    basicDA: 22000.00,
    hra: 7000.00,
    conveyance: 1800.00,
    washing: 1200.00,
    gross: 32000.00,
    revision: "Revision 2",
  },
  ];

  const columns = [
  { Header: "S.No", Cell: ({ row }) => sampleData.length - row.index, className: "serial-no", applyHeaderClass: true, },
  { Header: "Employee Code", accessor: "employeeCode" },
  { Header: "Employee Name", accessor: "employeeName" },
  { Header: "Increment Date", accessor: "incrementDate" },
  { Header: "Increment Type", accessor: "incrementType" },
  { Header: "(BASIC + DA)", accessor: "basicDA" },
  { Header: "HRA", accessor: "hra" },
  { Header: "CONVEYANCE", accessor: "conveyance" },
  { Header: "WASHING", accessor: "washing" },
  { Header: "Gross", accessor: "gross" },
  { Header: "Revision", accessor: "revision" },
];

  const handleSearch = () => {
    setData(sampleData);
  };

  // select custome style
  const SelectcustomStyles = {
    control: (base) => ({
      ...base,
      maxheight: 33.1,
      minHeight: 33.1,
      // overflow: "scroll",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      padding: "0", // Match the padding for both dropdown and clear indicator
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px 8px", // Ensure consistent padding for dropdown indicator
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px 8px", // Adjust padding for clear indicator to match dropdown
    }),
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Employee Increment Report" breadcrumbItem="Employee Increment Report" />

          <Row>
            <Card>
              <CardBody>
                <Row>
                  <Col md={4}>
                    <label>From *</label>
                    <DatePicker selected={fromDate} onChange={(date) => setFromDate(date)} className="form-control" />
                  </Col>
                  <Col md={4}>
                    <label>To *</label>
                    <DatePicker selected={toDate} onChange={(date) => setToDate(date)} className="form-control" />
                  </Col>
                  <Col md={4}>
                    <label>Employee</label>
                    <Select
                      styles={SelectcustomStyles} 
                      id="employee"
                      name="employee"
                      options={dropdownAutoList.map(emp => ({ value: emp.emp_id.toString(), label: emp.emp_no }))}
                      value={selectedEmployee}
                      onChange={(selected) => setSelectedEmployee(selected)}
                      className="hrms-select"
                      classNamePrefix="hrms-select"
                    />
                  </Col>
                  <Col className="text-end mt-3">
                    <Button type="submit" className="btn button-search me-2" onClick={handleSearch}>
                      <i className="fas fa-search me-1" /> Search
                    </Button>
                    <Button type="button" className="btn button-export "> 
                      <i className="fas fa-file-export me-1" /> Export 
                    </Button> 
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                   <TableContainer columns={columns} data={sampleData} isGlobalFilter={true} customPageSize={10} className="custom-header-css" />
                
                  {/* <table className="table table-bordered">
                    <thead className="table-light">
                      <tr>
                        <th>Employee Code</th>
                        <th>Employee Name</th>
                        <th>Increment Date</th>
                        <th>Increment Type</th>
                        <th>(BASIC + DA)</th>
                        <th>HRA</th>
                        <th>CONVEYANCE</th>
                        <th>WASHING</th>
                        <th>Gross</th>
                        <th>Revision</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.length > 0 ? (
                        data.map((item, index) => (
                          <tr key={index}>
                            <td>{item.employeeCode}</td>
                            <td>{item.employeeName}</td>
                            <td>{item.incrementDate}</td>
                            <td>{item.incrementType}</td>
                            <td>{item.basicDA.toFixed(2)}</td>
                            <td>{item.hra.toFixed(2)}</td>
                            <td>{item.conveyance.toFixed(2)}</td>
                            <td>{item.washing.toFixed(2)}</td>
                            <td>{item.gross.toFixed(2)}</td>
                            <td>{item.revision}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="10" className="text-center text-danger">
                            NO RECORDS FOUND
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table> */}
              </CardBody>
            </Card>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EmployeeIncrementReport;
